(function () {
    'use strict';

    angular
        .module('iMatApp')
        .factory('productErrorHandler', productErrorHandler);

    productErrorHandler.$inject = ['productIssueFactory'];

    function productErrorHandler(productIssueFactory) {
        return {
            handle: handle
        };

        // -------------------------------------------------------------------------------------

        function handle(product, reason) {
            if (angular.isObject(reason) && reason.hasOwnProperty('code')) {
                return handlePricingErrors(reason, product);
            }

            switch (reason) {
                case 'Invalid file type':
                    return productIssueFactory.createInvalidFileType(product);
                case 'File size too big':
                    return productIssueFactory.createInvalidFileSize(product);
                case 'File name too long':
                    return productIssueFactory.createFileNameTooLong(product);
                case 'Upload file failed':
                    return productIssueFactory.createUploadFileError(product);

                case 'Not accepted V3 results':
                    return productIssueFactory.createNotAcceptedV3ResultsWarning(product);
                case 'Model already has repair results':
                    return productIssueFactory.createAlreadyHasV3ResultsWarning(product);
                case 'Invalid model':
                    return productIssueFactory.createInvalidModelError(product);
                case 'Processing failed':
                    return productIssueFactory.createProcessingFailedError(product);
                case 'Aborted model':
                    return productIssueFactory.createModelIsAborted(product);

                default:
                    return productIssueFactory.createGeneralError(product);
            }
        }

        function handlePricingErrors(reason, product) {
            switch (reason.code) {
                case 'DimensionsUnderLimit':
                    return productIssueFactory.createDimensionsUnderLimit(product, reason);
                case 'DimensionsBelowLimit':
                    return productIssueFactory.createDimensionsBelowLimit(product, reason);
                case 'DimensionsAboveLimit':
                    return productIssueFactory.createDimensionsAboveLimit(product, reason);
                case 'PriceLimit':
                    return productIssueFactory.createPriceLimit(product);
                case 'NoOnlinePrice':
                    return productIssueFactory.createNoOnlinePrice(product);
                default: //'PriceError':
                    return productIssueFactory.createPriceError(product);
            }
        }
    }
}());